// settings listing utils
import i18n from '@/translations/lang'

export default {
  data() {
    return {
      searchListData: [],
      isBeta: false,
    }
  },
  mounted() {
    this.isBeta = location.search.match('beta')
    this.updateSearchList()
    this.$root.$on('changeLanguage', this.updateSearchList)
  },
  beforeDestroy() {
    this.$root.$off('changeLanguage', this.updateSearchList)
  },
  computed: {
    searchList() {
      return this.searchListData
    },
  },
  methods: {
    updateSearchList() {
      this.searchListData = [
        {
          setting_name: `${ i18n.t('message.pages.video.colors')}`,
          setting_id: 'colors'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.bigPlayButton') }`,
          setting_id: 'big-play-button'
        },
        {
          setting_name: `${ i18n.t('message.ai.dubbings.dubbing') }`,
          setting_id: 'dubbing'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.thumbnails') }`,
          setting_id: 'thumbnails'
        },
        {
          setting_name: `${ i18n.t('message.pages.video.chapters')}`,
          setting_id: 'chapters'
        },
        {
          setting_name: `${ i18n.t('message.ai.mindmap.mindmap') }`,
          setting_id: 'mindmap'
        },
        {
          setting_name: `${ i18n.t('message.ai.abstract.ebook') }`,
          setting_id: 'ebook'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.miniTriggers') }`,
          setting_id: 'mini-trigger'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.smartAutoplay') }`,
          setting_id: 'smart-autoplay'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.alternativeProgress') }`,
          setting_id: 'alternative-progress'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoEditModal.subtitles') }`,
          setting_id: 'subtitle'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.saveProgress') }`,
          setting_id: 'save-progress'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.videoSpeed') }`,
          setting_id: 'video-speed'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.affiliate') }`,
          setting_id: 'affiliate'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.pip') }`,
          setting_id: 'pip'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.pixels') }`,
          setting_id: 'pixels'
        },
        {
          setting_name: `${ i18n.t('message.pages.video.buttons') }`,
          setting_id: 'custom-buttons'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.showPreviewThumbs') }`,
          setting_id: 'show-preview-thumbs'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.qualities') }`,
          setting_id: 'quality'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.drm') }`,
          setting_id: 'drm'
        },
        {
          setting_name: 'Quiz',
          setting_id: 'quiz'
        },
        {
          setting_label: `${ i18n.t('message.routesTitles.Metrics') }`,
          normalized_setting_name: this.removeDiacritics(`${ i18n.t('message.routesTitles.Metrics') }`),
          setting_id: 'metrics'
        },
        {
          setting_name: 'Analytics',
          setting_id: 'analytics'
        },
        {
          setting_name: 'HLS',
          setting_id: 'hls'
        },
        {
          setting_name: 'Performance',
          setting_id: 'performance'
        },
        {
          setting_name: 'Tutor',
          setting_id: 'assistAi'
        },
        {
          setting_name: `${ i18n.t('message.embedModal.embed') }`,
          setting_id: 'embed',
        },
        {
          setting_name: `${ i18n.t('message.embedModal.shareVideo') }`,
          setting_id: 'share'
        },
        {
          setting_name: `${ i18n.t('message.replaceVideo') }`,
          setting_id: 'replace-video'
        },
        {
          setting_name: `${ i18n.t('message.pages.videoPage.settings.options.controls')}`,
          related_settings: [
            `${ i18n.t('message.pages.video.bigPlayButton') }`,
            `${ i18n.t('message.pages.video.controlsPage.forward') }`,
            `${ i18n.t('message.pages.video.controlsPage.backward') }`,
            `${ i18n.t('message.pages.video.controlsPage.captions') } `,
            `${ i18n.t('message.pages.video.controlsPage.pip') }`,
            `${ i18n.t('message.pages.video.controlsPage.settings') }`,
            'Play/Pause',
            'Volume',
            'Airplay',
            'Chromecast',
            'Fullscreen',
          ],
          setting_id: 'controls'
        },
      ]
    },
    removeDiacritics(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
  },
}
